import React from "react";

import AccountPlansListTab from "./AccountPlansListTab";

type Props = React.ComponentProps<typeof AccountPlansListTab>;

/**
 * My Accounts → Account Plans (and Exec Ops → Account Plans). Plans and Activity
 * became one view on 2026-10-29 (Sushant): the list carries who moved each plan
 * last, and an account's panel its whole version history. An old `?view=activity`
 * link lands here too.
 */
const AccountPlansTab: React.FC<Props> = props => (
  <AccountPlansListTab {...props} />
);

export default AccountPlansTab;
